function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9798 8.02021C12.175 7.82495 12.4916 7.82495 12.6869 8.02021L15.3131 10.6464C15.5084 10.8417 15.5084 11.1583 15.3131 11.3535L9.1133 17.5534C9.03961 17.627 8.94474 17.6759 8.84195 17.693L5.69048 18.2182C5.35207 18.2746 5.05868 17.9813 5.11508 17.6428L5.64032 14.4914C5.65746 14.3886 5.70628 14.2937 5.77997 14.22L11.9798 8.02021Z",
  fill: "#96A2AA"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6464 5.35355C14.8417 5.15829 15.1583 5.15829 15.3536 5.35355L17.9798 7.97978C18.175 8.17504 18.175 8.49162 17.9798 8.68689L16.6869 9.97978C16.4916 10.175 16.175 10.175 15.9798 9.97978L13.3536 7.35355C13.1583 7.15829 13.1583 6.84171 13.3536 6.64645L14.6464 5.35355Z",
  fill: "#96A2AA"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.950e47ce.svg";
export { ForwardRef as ReactComponent };